var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.product.photosURL.cover.first),expression:"product.photosURL.cover.first"}],staticClass:"img-fluid rounded",attrs:{"alt":"Role Image"}})}
var staticRenderFns = []

export { render, staticRenderFns }